import React, { useState } from 'react';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import Balloon from '@ckeditor/ckeditor5-build-balloon';

export function BalloonEditor(props) {
  const { initialValue, onChange, placeholder, setEditor, readOnly } = props;
  const [value, setValue] = useState(initialValue);

  const handleChange = value => {
    setValue(value);
    if (onChange && typeof onChange === 'function') onChange(value);
  };

  return (
    <>
      <CKEditor
        editor={Balloon}
        data={value || placeholder}
        onReady={editor => {
          if (typeof setEditor === 'function') setEditor(editor);
        }}
        disabled={readOnly}
        onChange={(_, editor) => {
          const data = editor.getData();
          if (data) handleChange(data);
        }}
      />
    </>
  );
}

/*
        onBlur={(event, editor) => {
          console.log('Blur.', editor);
        }}
        onFocus={(event, editor) => {
          console.log('Focus.', editor);
        }}
        config={{
          toolbar: [
            'heading',
            '|',
            'bold',
            'italic',
            'bulletedList',
            'numberedList',
            'blockQuote',
            'link',
            'alignment:left',
          ],
          heading: {
            options: [
              { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
              { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
              { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
            ],
          },
        }}
        */
